// export const url = "https://xtratoys.nextechltd.in/api";
// export const url = "https://adscpos.nextechltd.in/api";

// export const url = "http://103.241.144.228:8000/api";

export const url = "https://centralskia.nextechltd.in/api";
export const isAdmin = true;

export const adminUrl = "https://centralskia.nextechltd.in/api";
